// extracted by mini-css-extract-plugin
export var columnList = "_ff-0";